import { render, staticRenderFns } from "./MoleculeChooseViewBuildings.vue?vue&type=template&id=7086d3d2&"
import script from "./MoleculeChooseViewBuildings.vue?vue&type=script&lang=js&"
export * from "./MoleculeChooseViewBuildings.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeChooseViewBuildings.vue?vue&type=style&index=0&id=7086d3d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeChooseViewBuildings.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FbuildingV2%2FMoleculeChooseViewBuildings.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports